module.exports = __webpack_public_path__ + "static/img/404.50e1decb.png";